import { render, staticRenderFns } from "./DeductionDialog.vue?vue&type=template&id=8fedebd2&scoped=true"
import script from "./DeductionDialog.vue?vue&type=script&lang=js"
export * from "./DeductionDialog.vue?vue&type=script&lang=js"
import style0 from "./DeductionDialog.vue?vue&type=style&index=0&id=8fedebd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fedebd2",
  null
  
)

export default component.exports